require('./libs/lazyload2/lazyload');
//require('./plugins.min');
require('./svgxuse');
require('./app');
require('./script');
